import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _get from "lodash/fp/get";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/** @jsx jsx */


import { useConfig, useCurrentDoc } from 'docz';
import { ChevronDown } from 'gatsby-theme-docz/src/components/Icons';
import * as styles from 'gatsby-theme-docz/src/components/NavGroup/styles';
import { NavLink } from 'gatsby-theme-docz/src/components/NavLink';
import React from 'react';
import { jsx } from 'theme-ui';
import { NO_GROUP } from '../../hooks/useExtendedMenus';
import { Container } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NavGroup = function NavGroup(_ref) {
  var item = _ref.item,
      sidebarRef = _ref.sidebarRef;

  var _useConfig = useConfig(),
      _useConfig$menuDispla = _useConfig.menuDisplayName,
      menuDisplayName = _useConfig$menuDispla === void 0 ? {} : _useConfig$menuDispla;

  var currentDoc = useCurrentDoc();
  var currentDocRef = React.useRef();
  var name = item.name,
      menu = item.menu,
      extendedMenu = item.extendedMenu;

  var _React$useState = React.useState(currentDoc.menu === name || currentDoc.submenu === name),
      subheadingsVisible = _React$useState[0],
      setShowsubheadings = _React$useState[1];

  var toggleSubheadings = function toggleSubheadings() {
    return setShowsubheadings(!subheadingsVisible);
  };

  React.useEffect(function () {
    if (sidebarRef.current && currentDocRef.current) {
      sidebarRef.current.scrollTo(0, currentDocRef.current.offsetTop);
    }
  }, [sidebarRef]);
  var visible = menu && menu.length && subheadingsVisible;
  var menuUi = null;

  if (visible) {
    // has sub-menus
    var items = extendedMenu || [{
      name: NO_GROUP,
      menu: menu
    }];
    menuUi = items.map(function (inlineMenu) {
      if (inlineMenu.name === NO_GROUP) {
        return inlineMenu.menu.map(function (submenu) {
          if (currentDoc.route === submenu.route) {
            return jsx(NavLink, {
              key: submenu.id,
              item: submenu,
              ref: currentDocRef
            }, _get(submenu.name, menuDisplayName) || submenu.name);
          }

          return jsx(NavLink, {
            key: submenu.id,
            item: submenu
          }, _get(submenu.name, menuDisplayName) || submenu.name);
        });
      }

      return jsx(NavGroup, {
        key: "inlineMenu-" + inlineMenu.name,
        item: inlineMenu,
        sidebarRef: sidebarRef
      });
    });
  }

  return jsx(Container, {
    sx: _objectSpread(_objectSpread({}, styles.wrapper), {}, {
      my: 0
    }),
    "data-testid": "nav-group"
  }, jsx("button", {
    className: "nav-button",
    sx: styles.title,
    onClick: toggleSubheadings
  }, _get(name, menuDisplayName) || name, jsx(ChevronDown, {
    sx: styles.chevron({
      active: subheadingsVisible
    })
  })), jsx("div", {
    sx: {
      ml: 3
    },
    "data-testid": "nav-group-links"
  }, menuUi));
};

if (typeof NavGroup !== 'undefined' && NavGroup && NavGroup === Object(NavGroup) && Object.isExtensible(NavGroup) && !NavGroup.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavGroup, '__filemeta', {
    configurable: true,
    value: {
      name: "NavGroup",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/NavGroup/index.js"
    }
  });
}